export const BC_FORM_TYPES = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
} as const;
